import { c as _c } from "react/compiler-runtime";
export default function CreateWaveDropsMetadataAddRowButton(t0) {
  const $ = _c(6);
  const {
    itemsCount,
    onAddNewRow
  } = t0;
  const label = itemsCount ? "Add more" : "Add";
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <svg className="tw-h-5 tw-w-5 tw-mr-2 tw-flex-shrink-0" viewBox="0 0 24 24" fill="none" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"><path d="M12 5V19M5 12H19" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== label) {
    t2 = <span>{label}</span>;
    $[1] = label;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== onAddNewRow || $[4] !== t2) {
    t3 = <div className="tw-flex tw-justify-center"><button onClick={onAddNewRow} type="button" className={"tw-py-1 tw-px-2 tw-bg-transparent tw-border-0 tw-flex tw-items-center tw-text-sm tw-text-primary-400 hover:tw-text-primary-300 \n        tw-font-semibold tw-transition tw-duration-300 tw-ease-out"}>{t1}{t2}</button></div>;
    $[3] = onAddNewRow;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
}